import InsuranceBanner from './InsuranceBanner';
import InsuranceSection from './InsuranceSection';

function Insurance() {
  return (
    <div>
      <InsuranceBanner />
      <InsuranceSection />
    </div>
  );
}

export default Insurance;